import { render, staticRenderFns } from "./novoMenu.vue?vue&type=template&id=5e3b909b&scoped=true&"
var script = {}
import style0 from "./novoMenu.vue?vue&type=style&index=0&id=5e3b909b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3b909b",
  null
  
)

export default component.exports